import OrderTopbarOTBTotals from './OrderTopbarOTBTotals'
export default OrderTopbarOTBTotals
